import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
//import {Observable} from 'rxjs/Rx';

export class Serializable {
    fromJSON(json) {
        for (var propName in json)
            this[propName] = json[propName];
        return this;
    }
}

export class User extends Serializable {
public password: string;
public sessionId: string
	public GetEmail(): string { return this.email }
	public GetSessionId(): string { return this.sessionId }
	public ID: string;
	public insertDate: string;
  public topics: string[];
  public users: string[];
  public isDisabled: false;
  public passwdHashSalt: string;
	//
	public show: boolean = false;
	public edit: boolean = false;
	public checked: boolean = false;
	
	constructor(
		public email: string,
		public userId: string,
		public phone: string) {
                    super();
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/user/model/user.ts